// This file is generated by a script and should not be modified directly.
const markdown: string = "Postal address and geolocation linked to the company's SIRET number\n"
export default markdown
